import * as React from 'react'
import { Outlet } from 'react-router-dom'

import { Box, Spinner } from '@factorialco/deprecated-design-system'
import { PerformanceV2RootPageDocument } from 'generated/resources/graphql'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'
import { useQuery } from 'modules/core/hooks/useQuery'

import {
  PerformanceV2ModuleContext,
  PerformanceV2ModuleContextProps,
} from 'modules/performance_v2/hooks/usePerformanceV2ModuleContext'
import CollectionsBootstrap from 'modules/performance_v2/lib/CollectionsBootstrap'

const RootPage = () => {
  const { loading, data } = useQuery(PerformanceV2RootPageDocument)

  const hasAnalytics = data?.performance?._policies?.sidebarSeeAnalyticsSubLevelItem?.can
  const hasReviewProcess =
    data?.performance?._policies?.sidebarSeePerformanceReviewProcessSubLevelItem?.can
  const hasGoalsV2 = data?.goals._policies?.sidebarSeePerformanceGoalsV2SubLevelItem?.can
  const hasOneOnOnes = data?.oneOnOnes._policies?.sidebarSeePerformanceOneOnOnesSubLevelItem?.can
  const hasFeedbacks = data?.feedbacks._policies?.sidebarSeePerformanceFeedbacksSubLevelItem?.can
  const hasCycles = data?.performanceCycles._policies?.sidebarSeePerformanceCyclesSubLevelItem?.can
  const hasCompetencies =
    data?.competencies?._policies?.sidebarSeePerformanceCompetenciesSubLevelItem?.can ?? false

  if (loading)
    return (
      <Box width="full" alignItems="center" height="full" justifyContent="center">
        <Spinner />
      </Box>
    )

  const contextValue: PerformanceV2ModuleContextProps = {
    featuresAvailability: {
      hasReviewProcess,
      hasGoalsV2,
      hasOneOnOnes,
      hasFeedbacks,
      hasCycles,
      hasCompetencies,
      hasAnalytics,
    },
  }
  const authorizeFn = () => Object.values(contextValue.featuresAvailability).some(Boolean)

  return (
    <CollectionsBootstrap>
      <AuthorizeUser authorizeFn={authorizeFn}>
        <PerformanceV2ModuleContext.Provider value={contextValue}>
          <Outlet />
        </PerformanceV2ModuleContext.Provider>
      </AuthorizeUser>
    </CollectionsBootstrap>
  )
}

export default RootPage
